import React from 'react';
import { FormProps } from 'util/Form';
import PhoneFormItem from 'components/profile/PhoneFormItem/PhoneFormItem';

interface PhoneQuestionFormItemProps extends FormProps {
  fieldName: string;
}

const PhoneQuestionFormItem: React.FunctionComponent<PhoneQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
}) => {
  return <PhoneFormItem phoneFieldName={fieldName} label="" required={required} disabled={disabled} />;
};
export default PhoneQuestionFormItem;
